import styled from "styled-components"
import { Link } from "gatsby"
import media from "../../theme/breakpoints"

export const Tag = styled(Link)`
  display: inline-block;
  padding: ${props =>
    props.size === "small" ? "0.5rem 1.2rem" : "0.8rem 1.4rem"};
  background: ${props => props.theme.colors.main};
  border-radius: 5px;
  color: #fff;
  text-decoration: none;
  font-weight: 600;
  transition: 0.3s all ease;
  font-size: ${props => (props.size === "small" ? 1.4 : 1.6)}rem;

  ${media.md`
    font-size: 1.4rem;
    padding: 0.5rem 1.2rem;
  `}

  &:hover {
    background: ${props => props.theme.colors.hover};
  }
`
